export default __webpack_public_path__ + "static/media/logo_thtt.c9569dd2.png";